module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/hToVIC/tc-custom/9781439642566.jpg?1688985128899",
      "alt": "This image is the cover for the book Skiing in the Catskill Region, Images of Sports"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Skiing in the Catskill Region, Images of Sports\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Arriving by train to Phoenicia, New York, in the mid-1930s, downhill skiers first discovered the snowy trails of Simpson Ski Slope. Soon after, many Borscht Belt hotels were offering skiing and skating as ways to fill rooms during cold winter months when crowds thinned. In the high central Catskills, where abundant snowfall was a big draw, many abandoned rooming houses were commandeered to serve as base lodges for fledgling ski areas. In addition to farming and logging, skiing became an important industry to the area. People found steady employment in dozens of new areas sprouting all over the mountains. Downhill skiing is just part of the region�s history. Ski jumping, racing, ski clubs, fashion, and colorful personalities were all part of the experience.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      George V. Quinn\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("George V. Quinn comes from a skiing family and has authored a book on winter sports in the Catskills with a special focus on local backcountry skiing. He has collected many photographs since beginning to ski in the mid-1950s and remembers many of the small ski areas and their rise and their sometimes demise. Skiing in the Catskill Region shows many aspects of skiing as well as a special section for ski areas that are gone but not forgotten.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0